import { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useChangePasswordMutation } from "../../../../store/services/authServices";
import toast from "react-hot-toast";

const ManagePassword = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm();

  const [changePassword, { isLoading }] = useChangePasswordMutation();

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
  const onSubmit = async (data) => {
    try {
      await changePassword({ data: { oldPassword: data.oldPassword, newPassword: data.newPassword } }).unwrap();
      toast.success("Password changed successfully");
      reset();
    } catch (error) {
      toast.error(error?.data?.message || "Failed to change password");
    }
  };


  const eyeClosed = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
    >
      <path
        d="M17.8822 0.88158L17.1463 0.145638C16.9383 -0.0623533 16.5543 -0.0303442 16.3143 0.257601L13.7541 2.80157C12.602 2.30562 11.3382 2.06562 10.0101 2.06562C6.05798 2.08156 2.6342 4.38553 0.986083 7.69774C0.890056 7.90573 0.890056 8.16166 0.986083 8.33765C1.75402 9.90567 2.90609 11.2017 4.34609 12.1776L2.2501 14.3056C2.0101 14.5456 1.97809 14.9296 2.13813 15.1376L2.87408 15.8735C3.08207 16.0815 3.46606 16.0495 3.70606 15.7616L17.754 1.71369C18.058 1.47383 18.09 1.08987 17.882 0.881855L17.8822 0.88158ZM10.8581 5.71347C10.5861 5.64945 10.2981 5.56949 10.0261 5.56949C8.66606 5.56949 7.57818 6.65752 7.57818 8.01743C7.57818 8.28943 7.64219 8.57738 7.72215 8.8494L6.65003 9.90544C6.33008 9.34548 6.15409 8.72138 6.15409 8.01746C6.15409 5.88948 7.86611 4.17746 9.99409 4.17746C10.6982 4.17746 11.3221 4.35344 11.8821 4.6734L10.8581 5.71347Z"
        fill="#666666"
        fill-opacity="0.8"
      />
      <path
        d="M19.0347 7.69792C18.4747 6.57787 17.7386 5.56994 16.8267 4.75391L13.8507 7.69792V8.01787C13.8507 10.1459 12.1387 11.8579 10.0107 11.8579H9.69072L7.80273 13.7459C8.50679 13.8898 9.24274 13.9859 9.96274 13.9859C13.9149 13.9859 17.3386 11.6819 18.9868 8.35374C19.1307 8.12967 19.1307 7.90576 19.0347 7.69775L19.0347 7.69792Z"
        fill="#666666"
        fill-opacity="0.8"
      />
    </svg>
  );
  
  const eyeOpen = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9ZM12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46447 8.46447C9.40215 7.52678 10.6739 7 12 7C13.3261 7 14.5979 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5Z"
        fill="#666666"
      />
    </svg>
  );

  return (
    <section className="managePassword py-3 position-relative">
      <Container>
        <Row className="justify-content-center">
          <Col lg="12">
            <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">Change Password</h4>
          </Col>
          <Col lg="6" className="my-2">
            <div className="formWrapper px-lg-5 p-md-4 p-3 rounded" style={{ background: "#EEEEEE" }}>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                  <Col lg="12" className="my-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">Current Password</label>
                    <div className="position-relative">
                    <input
                      // type="password"
                      placeholder="Enter current password"
                      type={`${showOldPassword ? "text" : "password"}`}
                      //className="form-control"
                      className="form-control pe-5"
                      {...register("oldPassword", { required: "Current password is required" })}
                    />
                     <span
                    //className="icn absolute right-3 cursor-pointer"
                    className="position-absolute top-50 translate-middle-y end-0 me-3 cursor-pointer"
                    onClick={() => setShowOldPassword(!showOldPassword)}
                  >
                    {" "}
                    {showOldPassword ? eyeOpen : eyeClosed}
                  </span>
                  </div>
                    {errors.oldPassword && <span className="text-danger">{errors.oldPassword.message}</span>}
                  </Col>
                  

                  <Col lg="12" className="my-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">New Password</label>
                    <div className="position-relative">
                    <input
                      //type="password"
                      type={`${showPassword ? "text" : "password"}`}
                      placeholder="Enter new password"
                      //className="form-control"
                      className="form-control pe-5"
                      {...register("newPassword", { required: "New password is required" })}
                    />
                    <span
                    //className="icn absolute right-3 cursor-pointer"
                    className="position-absolute top-50 translate-middle-y end-0 me-3 cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {" "}
                    {showPassword ? eyeOpen : eyeClosed}
                  </span>
                  </div>
                    {errors.newPassword && <span className="text-danger">{errors.newPassword.message}</span>}
                  </Col>
                  <Col lg="12" className="my-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">Confirm New Password</label>
                    <div className="position-relative">
                    <input
                      //type="password"
                      type={`${showConfirmPassword ? "text" : "password"}`}
                      placeholder="Enter confirm new password"
                      //className="form-control"
                      className="form-control pe-5"
                      {...register("confirmNewPassword", {
                        required: "Confirm new password is required",
                        validate: (value) => value === watch("newPassword") || "Passwords do not match",
                      })}
                    />
                    <span
                    className="position-absolute top-50 translate-middle-y end-0 me-3 cursor-pointer"
                    //className="icn absolute right-3 cursor-pointer"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {" "}
                    {showConfirmPassword ? eyeOpen : eyeClosed}
                  </span>
                  </div>
                    {errors.confirmNewPassword && <span className="text-danger">{errors.confirmNewPassword.message}</span>}
                  </Col>
                  <Col lg="12" className="my-2">
                    <div className="d-flex align-items-center justify-content-center gap-10 mt-4">
                      <Button className="commonBtn GreyBtn" type="button" onClick={() => reset()}>Cancel</Button>
                      <Button className="commonBtn" type="submit" disabled={isLoading}>Submit</Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ManagePassword;





// import React, { useState } from "react";
// import { Button, Col, Container, Form, Row } from "react-bootstrap";
// import { useForm } from "react-hook-form";
// import { useChangePasswordMutation } from "../../../../store/services/authServices";
// import toast from "react-hot-toast";

// const ManagePassword = () => {
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     reset,
//   } = useForm();

//   const [changePassword, { isLoading }] = useChangePasswordMutation();
  
//   const onSubmit = async (data) => {
//     try {
//       await changePassword({ data }).unwrap();
//       toast.success("Password changed successfully");
//       reset();
//     } catch (error) {
//       toast.error(error?.data?.message || "Failed to change password");
//     }
//   };
//

//   return (
//     <section className="managePassword py-3 position-relative">
//       <Container>
//         <Row className="justify-content-center">
//           <Col lg="12">
//             <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">Change Password</h4>
//           </Col>
//           <Col lg="6" className="my-2">
//             <div className="formWrapper px-lg-5 p-md-4 p-3 rounded" style={{ background: "#EEEEEE" }}>
//               <Form onSubmit={handleSubmit(onSubmit)}>
//                 <Row>
//                   <Col lg="12" className="my-2">
//                     <label className="form-label fw-sbold text-muted ps-2 m-0">Current Password</label>
//                     <input
//                       type="password"
//                       placeholder="Enter current password"
//                       className="form-control"
//                       {...register("oldPassword", { required: "Current password is required" })}
//                     />
//                     {errors.oldPassword && <span className="text-danger">{errors.oldPassword.message}</span>}
//                   </Col>
//                   <Col lg="12" className="my-2">
//                     <label className="form-label fw-sbold text-muted ps-2 m-0">New Password</label>
//                     <input
//                       type="password"
//                       placeholder="Enter new password"
//                       className="form-control"
//                       {...register("newPassword", { required: "New password is required" })}
//                     />
//                     {errors.newPassword && <span className="text-danger">{errors.newPassword.message}</span>}
//                   </Col>
//                   <Col lg="12" className="my-2">
//                     <div className="d-flex align-items-center justify-content-center gap-10 mt-4">
//                       <Button className="commonBtn GreyBtn" type="button" onClick={() => reset()}>Cancel</Button>
//                       <Button className="commonBtn" type="submit" disabled={isLoading}>Submit</Button>
//                     </div>
//                   </Col>
//                 </Row>
//               </Form>
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </section>
//   );
// };

// export default ManagePassword;
